<template>
    <div class="w-full" v-if="isLoggedIn">

    <div id="conversations-wrapper" style="width: 100%; height: 500px;"></div>

    </div>
    <div class="flex flex-column w-full" v-if="!isLoggedIn">
    <div class="w-full py-3 align-items-center text-600">
        <span>Кажется вы не авторизированы</span>
    </div>
    <div class="w-full py-3">
        <Button label="Войти" @click="goAuth" class="p-button-lg w-full border-round-lg"/>
    </div>
    </div>
</template>


<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    data() {
        return {
            header: {
                en: {name: "Chat"} ,
                ru: {name: "Чат"} ,
            }, 
        }
    },
    methods: {
        goAuth(){
            this.$router.push({path: '/mr/auth/'})
        },
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        window.BrevoConversationsSetup = {
            mode: 'frame',
            injectTo: 'conversations-wrapper',
        };

        try {
            BrevoConversations('restart')
        } catch (e) {
            console.log(e)
        }
	},
}
</script>